<template>
	<div class="">
		<div class="top-operation">
			<el-button type="primary" @click="editPositon()">新增职位</el-button>
		</div>
		<positionSearch ref="positionSearch" @searchPosition="handleCurrentChange"></positionSearch>
		<el-table :data="positionListData" border header-row-class-name="tableHead" v-loading="tableLoading">
			<el-table-column prop="id" label="招聘ID" :resizable="false" align="center" width="80"></el-table-column>
			<el-table-column prop="jobName" label="招聘名称" :resizable="false" align="center"></el-table-column>
			<el-table-column prop="jobType" label="类型" :resizable="false" align="center">
				<template slot-scope="scope">
					<span>{{scope.row.jobType == 1 ? '兼职' : '全职'}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="salary" label="薪资" :resizable="false">
				<template slot-scope="scope">
					<span v-if="scope.row.salaryType == 0">面议</span>
					<span v-if="scope.row.salaryType == 1 && scope.row.jobType == 0">{{scope.row.minSalary}}元 -
						{{scope.row.maxSalary}}元</span>
					<span
						v-if="scope.row.salaryType == 1 && scope.row.jobType == 1">{{scope.row.salaryOne}}元/{{scope.row.salaryOneType == 0 ? '天' : '次'}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="fullAddress" label="地址" :resizable="false"></el-table-column>
			<el-table-column label="状态" :resizable="false" align="center" width="80">
				<template slot-scope="scope">
					<span>{{scope.row.status == 1 ? '上架中' : '已下架'}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="updatedAt" label="更新时间" align="center" width="150" :resizable="false">
				<template slot-scope="scope">
					<div>{{ scope.row.updatedAt | formatDate }}</div>
				</template>
			</el-table-column>
			<el-table-column label="投递人数" align="center" width="80" :resizable="false">
				<template slot-scope="scope">
					<router-link :to="{ name:'recruit/delivery', query:{ jobId: scope.row.id }}">{{scope.row.resumeCount}}
					</router-link>
				</template>
			</el-table-column>
			<el-table-column label="操作" :resizable="false" min-width="350px">
				<template slot-scope="scope">
					<div class="operate">
						<el-button size="mini" type="primary" @click="editPositon(scope.row.id)">编辑</el-button>
						<el-button size="mini" type="danger" @click="hanleDelete(scope.row.id)">删除</el-button>
						<el-button size="mini" type="success" @click="hanleChangeTime(scope.row.id)">擦亮</el-button>
						<el-button size="mini" type="info" @click="changePositionState(scope.row.id, scope.row.status)">
							{{scope.row.status === 1 ? '下架' : '上架'}}</el-button>
						<el-button size="mini" type="primary" @click="showCodeDialog(2, scope.row.id, scope.row.name)">招聘二维码
						</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<table-pagination :pageTotal="tableTotal" :pageIndex="pageData.pageNumber"
			@handlePageChange="handleCurrentChange" />
	</div>
</template>
<script>
import positionSearch from './components/search';
import recruitPosition from '@/services/recruit/position';
export default {
	data () {
		return {
			tableLoading: false,
			tableTotal: 0,
			pageData: {
				pageNumber: 1,
				pageSize: 10
			},
			positionListData: []
		}
	},
	components: {
		positionSearch
	},
	mounted () {
		this.getPositionListData();
	},
	methods: {
		getPositionListData () {
			let data = {
				...this.pageData,
				...this.$refs.positionSearch.positionSearch
			}
			this.tableLoading = true;
			recruitPosition.jobList(data).then(res => {
				this.tableTotal = res.result.total;
				this.positionListData = res.result.data;
				this.tableLoading = false;
			}).catch(() => { })
		},
		editPositon (id) {
			id ? this.$router.push({ name: 'recruit/edit', query: { id: id } }) : this.$router.push({ name: 'recruit/edit' })
		},
		hanleDelete (id) {
			const h = this.$createElement;
			this.$msgbox({
				title: '消息',
				message: h('p', null, `是否删除该职位!`),
				showCancelButton: true,
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				beforeClose: (action, instance, done) => {
					if (action === 'confirm') {
						instance.confirmButtonLoading = true;
						instance.confirmButtonText = `删除中...`;
						recruitPosition.jobDelete(id).then(() => {
							this.$message.success(`删除成功！`);
							done();
							this.getPositionListData()
							instance.confirmButtonLoading = false;
						})
					} else {
						done();
						instance.confirmButtonLoading = false;
						instance.confirmButtonText = '确定';
					}
				}
			})
		},
		hanleChangeTime (id) {
			const h = this.$createElement;
			this.$msgbox({
				title: '消息',
				message: h('p', null, `是否擦亮该职位!`),
				showCancelButton: true,
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				beforeClose: (action, instance, done) => {
					if (action === 'confirm') {
						instance.confirmButtonLoading = true;
						instance.confirmButtonText = `擦亮中...`;
						recruitPosition.changeJobTime(id).then(() => {
							this.$message.success(`擦亮成功！`);
							done();
							this.getPositionListData()
							instance.confirmButtonLoading = false;
						})
					} else {
						done();
						instance.confirmButtonLoading = false;
						instance.confirmButtonText = '确定';
					}
				}
			})
		},
		changePositionState (id, state) {
			const h = this.$createElement;
			const t = state === 2 ? '上架' : '下架'
			this.$msgbox({
				title: '消息',
				message: h('p', null, `是否${t}该职位!`),
				showCancelButton: true,
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				beforeClose: (action, instance, done) => {
					if (action === 'confirm') {
						instance.confirmButtonLoading = true;
						instance.confirmButtonText = `${t}中...`;
						recruitPosition.changeJobState(id).then(() => {
							this.$message.success(`${t}成功！`);
							done();
							this.getPositionListData()
							instance.confirmButtonLoading = false;
						})
					} else {
						done();
						instance.confirmButtonLoading = false;
						instance.confirmButtonText = '确定';
					}
				}
			})
		},
		handleCurrentChange (val) {
			this.pageData.pageNumber = val;
			this.getPositionListData()
		},
		handleClose () {
			this.codeParams.diaLogFromVisible = false;
		}
	}
}
</script>
<style lang="scss" scoped>
.BtnBoxZero {
	display: inline-block;
	margin-right: 10px;
}

.BtnBoxOne {
	display: inline-block;
	margin-right: 10px;
	width: 116px;
}

.BtnBoxTwo {
	display: inline-block;
	margin-right: 10px;
	width: 130px;
}
.BtnBoxthree {
	display: inline-block;
	margin-right: 10px;
	width: 102px;
}
.operate {
	display: flex;
	justify-content: space-around;
	align-items: center;
}
</style>
